export default {
    data: () => ({
        captchaIsVerify: true,
        formCaptcha: null,
    }),
    computed: {
        captchaEnabled () {
            return this.captchaSiteKey !== null
        },
        captchaSiteKey () {
            const siteKeyElement = document.head.querySelector(
                'meta[name="recaptcha-site-key"]')
            if (siteKeyElement && siteKeyElement.content) {
                return siteKeyElement.content
            }
            return null
        },
    },
    methods: {
        changeCaptchaToken(token) {
            this.captchaIsVerify = !!token
            this.formCaptcha = token;
        },
        changeCapthaStatus(status) {
            this.captchaIsVerify = status
        },
    }
}
